<template>
  <div>
    <!-- Gurudwara list -->
    <div class="p-6 pt-0">
      <div v-if="!isAddModalShow && !isEditModalShow">
        <vs-table
          id="service-list"
          class="vs-con-loading__container"
          stripe
          :sst="true"
          maxHeight="800px"
          @search="updateSearchQuery"
          @change-page="handleChangePage"
          @sort="handleSort"
          :total="FilteredCount"
          :max-items="length"
          search
          :data="records"
        >
          <template slot="header">
            <div class="mb-2 flex items-center">
              <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                  <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                      <span class="mr-2">
                        {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                        -
                        {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                        of {{ total || 0 }}
                      </span>
                      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="handleChangeLength(10)">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(20)">
                        <span>20</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(50)">
                        <span>50</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="handleChangeLength(100)">
                        <span>100</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
              <div class="flex flex-wrap items-center">
                <!-- Custom Pagination -->
                <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
              </div>
              <vs-button v-if="checkPermissionSlug(['available_service_create'])" @click="toggleAddModal" color="primary" size="default" style="padding: 12px 30px">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add {{ module_name }}</vs-button
              >
            </div>
          </template>

          <template slot="thead">
            <vs-th>Sr#</vs-th>
            <vs-th>{{ module_name }} Name</vs-th>
            <vs-th v-if="checkPermissionSlug(['available_service_edit'])">Visible</vs-th>
            <vs-th v-if="checkPermissionSlug(['available_service_edit', 'available_service_delete', 'available_service_view'])">Action</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="checkPermissionSlug(['available_service_edit'])" @click.stop="toggleEditModal(tr._id)" v-tooltip="{ content: `Edit ${tr.service_name}` }">{{
                  tr.service_name || '-'
                }}</span>
                <span v-else>{{ tr.service_name || '-' }}</span>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['available_service_edit'])">
                <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['available_service_edit', 'available_service_delete', 'available_service_view'])">
                <div class="inline-flex">
                  <vx-tooltip
                    v-if="checkPermissionSlug(['available_service_edit', 'available_service_view'])"
                    :text="`${checkPermissionSlug(['available_service_edit']) ? 'Edit' : 'View'} ${module_name}`"
                  >
                    <feather-icon
                      @click.stop="toggleEditModal(tr._id)"
                      :icon="checkPermissionSlug(['available_service_edit']) ? 'EditIcon' : 'EyeIcon'"
                      svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer"
                    />
                  </vx-tooltip>
                  <vx-tooltip v-if="checkPermissionSlug(['available_service_delete'])" :text="`Delete ${module_name}`">
                    <feather-icon @click.stop="deleteRecord(tr._id)" icon="TrashIcon" svgClasses="h-6 w-6 mr-4 hover:text-primary cursor-pointer" />
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <!-- Add modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isAddModalMounted" :showModal.sync="isAddModalShow" :action_name="'Add'" />
      <!-- Edit modal -->
      <action-modal :module_name="module_name" @update-data="getData" v-if="isEditModalMounted" :showModal.sync="isEditModalShow" :selectedRecordId="selectedRecordId" :action_name="'Update'" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import actionModal from './action'

export default {
  name: 'Service-List',
  components: { actionModal },
  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Service',
    route_slug: 'service',
    // Add modal
    isAddModalMounted: false,
    isAddModalShow: false,

    // Edit modal
    isEditModalMounted: false,
    isEditModalShow: false,
    selectedRecordId: null
  }),

  /** computed */
  computed: {
    ...mapState('availableService', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('availableService', {
      get: 'get',
      delete: 'delete'
    }),

    /** toggle modal */
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
      this.selectedRecordId = null
    },

    // Edit
    toggleEditModal(id) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecordId = id
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Organization List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search,
        organization: this.$route.params.id
      })
    },

    /** Delete Organization Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Organization API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('availableService/updateStatus', {
          id
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    }
  },

  /** Watchers */
  watch: {
    // listLoading() {
    //   if (this.listLoading) {
    //     this.$vs.loading({
    //       container: '#service-list',
    //       scale: 0.45
    //     })
    //   } else {
    //     this.$vs.loading.close('#service-list > .con-vs-loading')
    //   }
    // },
    page() {
      this.getData()
    },
    // Add modal
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
          }, 0)
        }
      }
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
